import { Store } from '@categoryProduct/store/typings';
import getBabySettings from '@categoryProduct/store/design/selector/getBabySettings';

export default (state: Store, section: string) => {
  const settings = getBabySettings(state, section);
  return settings ? Number(settings.o) : null;
}
